/* eslint-disable @typescript-eslint/no-explicit-any */
import { api_service } from '../api/api-service';
import { api_urls } from '../api/api-urls';

export interface CompleteRegistrationInviteDetails {
    firstName?: string;
    lastName?: string;
    name?: string;
    email?: string;
    phoneNumber?: string;
    accountType?: string;
    contractId?: string;
    street?: string;
    city?: string;
    state?: string;
    country?: string;
    postalCode?: string;
}

export interface AdminRegistrationResponse {
    statusCode: number;
    data?: CompleteRegistrationInviteDetails | Record<string, any>;
    message?: string;
}

/**
 * Fetch read-only prefill details for an admin-assisted registration invite link.
 * The token is validated by the backend directly from the URL path — no auth header needed.
 * @param token - Invite token from the /complete-registration/:token URL
 * @param showLoader - Whether to show loader
 */
export const getRegistrationInviteByToken = async (
    token: string,
    showLoader: boolean = true,
): Promise<AdminRegistrationResponse> => {
    try {
        const response: any = await api_service.get({
            endPoint: `${api_urls.CompleteRegistrationDetails}/${token}`,
            showLoader,
        });
        return response?.data;
    } catch (error: any) {
        console.error('Error fetching registration invite details:', error);
        throw error;
    }
};

/**
 * Complete an admin-assisted registration by setting a password for the invited customer.
 * @param token - Invite token from the /complete-registration/:token URL
 * @param password - New password chosen by the customer
 * @param showLoader - Whether to show loader
 */
export const completeRegistrationInvite = async (
    token: string,
    password: string,
    showLoader: boolean = true,
): Promise<AdminRegistrationResponse> => {
    try {
        const response: any = await api_service.post({
            endPoint: `${api_urls.CompleteRegistrationDetails}/${token}/complete`,
            showLoader,
            payLoad: { password },
        });
        return response?.data;
    } catch (error: any) {
        console.error('Error completing registration invite:', error);
        throw error;
    }
};
